import React, { memo, useContext, useEffect } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import Skeleton from '@material-ui/lab/Skeleton'

import { useDrag } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'

import { hex } from 'utils/hex'
import { devicesIconComponent } from 'constants/deviceTypeConstants'
import CustomScroll from 'components/CommonUI/CustomScroll/CustomScroll'
import { DeviceContext } from '../DeviceConnectionContainer'

const DevicesSection = ({ data = [], isFetching }) => {
  const { state } = useContext(DeviceContext)

  const _filterindDevices = data?.filter((device) =>
    String(device?.name)
      .toLowerCase()
      .includes(String(state.searchDeviceValue).toLowerCase())
  )

  return (
    <div className="devices_section">
      <div className="devices_section_container">
        <CustomScroll isHorisontal={true}>
          {_filterindDevices?.length ? (
            _filterindDevices.map((device) => {
              return <DeviceItem key={device.id} {...device} />
            })
          ) : (
            <span className="devices_section_noresult">
              {isFetching ? 'Loading...' : 'No result'}
            </span>
          )}
        </CustomScroll>
      </div>
      {isFetching && (
        <div className="loader_container">
          <Skeleton
            className="loader"
            variant="rect"
            animation="wave"
            width="100%"
            height="76px"
          />
        </div>
      )}
    </div>
  )
}

const DeviceItem = memo(
  ({ icon = '', color, name = '', id = '', style = {} }) => {
    const Icon = devicesIconComponent[icon]?.ComponentIcon

    const [{ isDragging }, drag, preview] = useDrag(
      () => ({
        type: 'DEVICE',
        item: { device_id: id, color, icon, name },
        options: {
          dropEffect: 'copy',
        },
        collect: (monitor) => {
          return {
            isDragging: monitor.isDragging(),
          }
        },
      }),
      [id, color, icon]
    )

    useEffect(() => {
      preview(getEmptyImage(), { captureDraggingState: true })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const draggingClassName = isDragging ? 'dragging' : ''

    return (
      <>
        <div
          className={`device_item device_block ${draggingClassName}`}
          style={{
            backgroundColor: hex(color),
            ...style,
          }}
          ref={drag}
        >
          <Icon className="device_item_icon" color={color} />
          <Tooltip title={<span style={{ fontSize: '13px' }}>{name}</span>} placement="top">
            <span
              className="device_item_name"
              style={{
                color,
              }}
            >
              {name}
            </span>
          </Tooltip>
        </div>
      </>
    )
  }
)

export default DevicesSection
